import {computed, ref, watchEffect} from "vue";
import * as CoreService from '@/api';
import {ILocation} from "@/models/Location";
import debounce from 'lodash.debounce';
import {getPopularDestinations} from "@/api";

export const useDestinationAutocomplete = () => {

    const locations = ref<ILocation[]>([]);
    const popular = ref<ILocation[]>([])
    const loading = ref(false);
    const hasResults = computed(() => { return locations.value.length > 0; });
    const hasPopular = computed(() => { return popular.value.length > 0; });
    const query = ref('')

    const getPopularDestinations = () => {
        loading.value = true;
        popular.value = [];
        CoreService.getPopularDestinations()
            .then((response) => {
                popular.value =response.data
            }).finally(() => {
                loading.value = false;
        })
    }

    const fetch=()=>{

        loading.value = true

        let cleanQuery = query.value?.trim()
        if (cleanQuery === '' || cleanQuery.length <= 2) {
            locations.value = [];
            loading.value = false
        }else{
            debounce(() => {
                locations.value = [];
                CoreService.searchCombinedRecommendations(cleanQuery).then(data => {
                    locations.value = [...data.geolocations];
                }).finally(() => {
                    loading.value = false
                });
            }, 100)()
        }
    }


    const reset = ()=>{
        query.value = '';
        loading.value = false;
        locations.value = [];
    }

    watchEffect(() => {fetch()})
    return {
        locations,
        popular,
        query,
        loading,
        hasResults,
        hasPopular,
        reset,
        getPopularDestinations
    }

}
